export default {
  GET_COLORS: (state) => state.colors,
  GET_COLOR: (state) => state.color,
};
